import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { materialStatusView } from "../types/materialStatusView";
import {
  IMaterialStatus,
  IMaterialStatusGridFilter,
  IMaterialStatusGridModel,
} from "./types";

export const materialStatus = createQueryKeys("materialStatus", {
  list: (postModel: PostModel<IMaterialStatusGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IMaterialStatusGridModel>>(
        endpoints.materialStatus.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IMaterialStatus>(`${endpoints.materialStatus.getById}/${Id}`),
  }),

  getMaterialStatusValues: () => ({
    queryKey: ["GetMaterialStatusValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        endpoints.materialStatus.getMaterialStatusValues
      ),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<materialStatusView>(`${endpoints.materialStatus.view}/${Id}`),
  }),
});
